export const DICTIONARY_DIAMETER = {
	operations: {
		'16777238': {
			'272': {
				R: 'CCR',
				A: 'CCA',
				type: 'Gx',
			},
			'258': {
				R: 'RAR',
				A: 'RAA',
				type: 'Gx',
			},
		},
		'16777236': {
			265: {
				R: 'AAR',
				A: 'AAA',
				type: 'Rx',
			},
			258: {
				R: 'RAR',
				A: 'RAA',
				type: 'Rx',
			},
			275: {
				R: 'STR',
				A: 'STA',
				type: 'Rx',
			},
			274: {
				R: 'ASR',
				A: 'ASA',
				type: 'Rx',
			},
		},
		'0': {
			'257': {
				R: 'CER',
				A: 'CEA',
				type: 'Others',
			},
			'280': {
				R: 'DWR',
				A: 'DWA',
				type: 'Others',
			},
			'282': {
				R: 'DPR',
				A: 'DPA',
				type: 'Others',
			},
		},
	},
};
